import React from 'react';
import FormControl from '@mui/material/FormControl';
import SwitchComponent from './Switch.component';
import useDictionary from '@ui/hooks/useDictionary';
import { emptyFn } from '@core/interfaces/emptyFn';

interface IProps {
    ledState: boolean;
    onLedStateChange: emptyFn;
}

const Component: React.FC<IProps> = ({
    ledState,
    onLedStateChange,
}: IProps) => {
    const getWord = useDictionary();

    return (
        <FormControl className="device-settings__form" component="form">
            <SwitchComponent
                alarmState={ledState}
                name={'ledIndication'}
                tooltip={getWord('ledIndicationTooltip')}
                onAlarmStateChange={onLedStateChange}
            />
        </FormControl>
    );
};

const LedIndicationSettingsComponent = React.memo(Component);

export default LedIndicationSettingsComponent;
